import React, { useEffect } from "react";
import "./App.less";
import { Grid } from "semantic-ui-react";
import CitySelectorPage from "./common/components/CitySelectorPage";
import LeftMenu from "./common/components/LeftMenu";
import RightSideBar from "./geofence/components/RightSidebar";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect
} from "react-router-dom";
import GeofenceDraw from "./geofence/components/GeofenceDraw";
import CreateCity from "./geofence/components/CreateCity";
import LoginModal from "./common/components/LoginModal";
import CityView from "./geofence/components/CityView";
import { useSelector } from "react-redux";
import { Modal, Loader } from "semantic-ui-react";
import { useToasts } from "react-toast-notifications";
import RMBuddyDashboard from "./rm-buddies/components/RMBuddyDashboard";

function App() {
  const showLoaderModal = useSelector(
    ({ geofence }) => geofence.showLoaderModal
  );
  const errorToastMessage = useSelector(
    ({ geofence }) => geofence.errorToastMessage
  );
  const successToastMessage = useSelector(
    ({ geofence }) => geofence.successToastMessage
  );
  const { addToast } = useToasts();
  useEffect(() => {
    if (errorToastMessage && errorToastMessage.msg) {
      addToast(errorToastMessage.msg, {
        appearance: "error"
      });
    }
  }, [addToast, errorToastMessage]);

  useEffect(() => {
    if (successToastMessage && successToastMessage.msg) {
      addToast(successToastMessage.msg, {
        appearance: "success"
      });
    }
  }, [addToast, successToastMessage]);
  return (
    <div>
      <Router>
        <Modal open={showLoaderModal > 0} basic size="fullscreen">
          <Loader size="huge" />
        </Modal>
        <LoginModal />
        <Switch>
          <Route exact path="/">
            <CitySelectorPage />
          </Route>
          <Route path="/city">
            <LeftMenu />
            <Grid id="ViewGrid">
              <Grid.Column width={12}>
                <GeofenceDraw />
              </Grid.Column>
              <Grid.Column width={4}>
                <RightSideBar>
                  <Switch>
                    <Route path="/city/:cityName/geofences/">
                      <CityView />
                    </Route>
                    <Route exact path="/city/create">
                      <CreateCity />
                    </Route>
                    <Route render={() => <Redirect to="/" />} />
                  </Switch>
                </RightSideBar>
              </Grid.Column>
            </Grid>
          </Route>
          <Route exact path="/rmBuddies/">
            <LeftMenu />
            <RMBuddyDashboard />
          </Route>
          <Route exact path="/rmBuddies/excel/add">
            <LeftMenu />
            <RMBuddyDashboard />
          </Route>
          <Route path="/rmBuddies/:warehouseId/">
            <LeftMenu />
            <RMBuddyDashboard />
          </Route>
        </Switch>
      </Router>
    </div>
  );
}

export default App;
